// extracted by mini-css-extract-plugin
module.exports = {"content":"src-pages-guide-component-TaxAuthProtocol-protocol-AuthProtocol-XZProtocolContent-__index__content--WbRvM"};